import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiscoverComponent } from './simple-icons-discover.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiscoverComponent ],
    exports:      [ SimpleIconsDiscoverComponent ],
    bootstrap:    []
})
export class SimpleIconsDiscoverModule {}
